'use client';
import * as React from 'react';
import { type ReactNode } from 'react';
import { useHasMounted } from '@mentimeter/react-hooks';
import type { OpenFeatureSupportedFlags } from '@mentimeter/flags/openfeature/types';
import { DevelopmentToolsModal } from '../modal';
import { DevelopmentToolsProvider } from '../context';

export function DevelopmentToolsSetup({
  isAuthorizedToInteractWithDevelopmentTools,
  confidenceExperiments = {},
  children,
}: {
  isAuthorizedToInteractWithDevelopmentTools: boolean;
  confidenceExperiments?: OpenFeatureSupportedFlags;
  children: ReactNode;
}) {
  const hasMounted = useHasMounted();

  if (!isAuthorizedToInteractWithDevelopmentTools) return children;

  return (
    <DevelopmentToolsProvider>
      {children}
      {hasMounted && (
        <DevelopmentToolsModal confidenceExperiments={confidenceExperiments} />
      )}
    </DevelopmentToolsProvider>
  );
}
